import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DateTimeControlComponent } from "./date-time-control.component";
import { BsDatepickerModule } from "ngx-bootstrap";
import { DatePicker } from "@ionic-native/date-picker";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        BsDatepickerModule.forRoot()
    ],
    declarations: [
        DateTimeControlComponent
    ],
    exports: [
        DateTimeControlComponent
    ],
    providers: [
        DatePicker
    ]
})
export class DateTimeControlModule {}



// WEBPACK FOOTER //
// ./src/vas/controls/datetime/form/date-time-control.module.ts